
<template>
<div class="HelpPage">
  <header-component></header-component>
  <div v-html="legacySystemHTML"></div>
<div class="container g-py-40" id="contactDiv">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pp_image g-px-0">
                <div style="position: relative; width: 100%; height: 0; padding-bottom: 56.25%;">
                    <iframe src="//www.youtube-nocookie.com/embed/b-_NCXXtLe4?showinfo=0&rel=0&modestbranding=1&autoplay=1&mute=1" frameborder="0" allowfullscreen style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></iframe>
                </div>
            </div>
      </div>
      
             <div class="container-fluid">
              <div class="u-shadow-v35 g-bg-white rounded g-py-0 g-pb-35">
            <div class="text-center">
                <p class="g-color-text-light-v1 g-font-size-16 g-font-weight-500"></p>
                <a @click.prevent="handleBack('/')" class="btn g-font-size-16 u-shadow-v33 g-color-white g-bg-primary g-bg-main--hover g-rounded-30 g-px-35 g-py-13">Back</a>  
</span>
                <a v-on:click="RedirectToSignUp()" class="btn g-font-size-16 u-shadow-v33 g-color-white g-bg-primary g-bg-main--hover g-rounded-30 g-px-35 g-py-13">Sign Up</a>     
            </div></div>
        </div>

  <footer-component></footer-component>
  
</div>
</template>
<script>
import HeaderComponent from "@/components/shared/HeaderComponent";
import FooterComponent from "@/components/shared/FooterComponent";
export default {
  components: {HeaderComponent, 
               FooterComponent
              },
  data () {
  return {
      fromRoute: null
    }
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.fromRoute = from;
    })
  },

  methods: {
    RouterRedirect(name){
      this.$router.push({name: name});
        },
    RedirectToSignUp(){
      this.$router.push({name: 'Registration', params: {type:0}});
        },
    GoBackOne(){
      this.$router.go(-1);
        },
    handleBack (fallback) {
      if (!this.fromRoute.name) {
        this.$router.push(fallback);
      } else {
        this.$router.back();
      }
    },    
    
  },
  created() {
     localStorage.setItem('is-active','Resources');
  }
}
</script>


// WEBPACK FOOTER //
// Demo.vue?09efc971